// 审批状态
export const applyStatus = [
    { value: 'WAIT_REVIEW', text: '待复核' },
    { value: 'REVIEW_FAILED', text: '复核不通过' },
    { value: 'REVIEW_SUCCESS', text: '复核通过' },
    { value: 'WAIT_FOR_APPLICATION_FAILED', text: '轮候申请不通过' },
    { value: 'WAIT_FOR_APPLICATION_SUCCESS', text: '轮候申请通过' },
    { value: 'PRE_HOSPITAL_ASSESSMENT_FAILED', text: '院前评估失败' },
    { value: 'PRE_HOSPITAL_ASSESSMENT_SUCCESS', text: '院前评估通过' },
    { value: 'ADMITTED_TO_HOSPITAL', text: '已入院' },
    { value: 'WAIT_REVISE', text: '待修改' },
    { value: 'END', text: '结束' },
    { value: 'INVALID_IF_EXPIRED', text: '逾期作废' },
    { value: 'ADMITTED_TO_HOSPITAL_FAIL', text: '入院失败' },
];
